import { render, staticRenderFns } from "./purchase_detail.vue?vue&type=template&id=098374a6&scoped=true&"
import script from "./purchase_detail.vue?vue&type=script&lang=js&"
export * from "./purchase_detail.vue?vue&type=script&lang=js&"
import style0 from "./purchase_detail.vue?vue&type=style&index=0&id=098374a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098374a6",
  null
  
)

export default component.exports